import api from '@/lib/axiosApi'

export default api
